import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import useInputObject from "../../../hooks/useInputObject";
import ProductInfo from "../../../pages/product/ProductInfo/ProductInfo";
import { addProduct, getMaxProductId } from "../../../http/api/ProductAPI";
import {
  MSG_ERR_DUPLICATED_PRODUCT_ID,
  MSG_ERR_UNEXPECTED,
} from "../../../common/message";

const onFocusInput = (event) => {
  event.target.select();
};

// 商品マスター追加ダイアログ
export default function AddProductMasterDialog({
  open,
  onClose,
  productData,
  openAddProductDialog,
  openAddProductDetailMasterDialog,
}) {
  const productDataInput = useInputObject({});

  // 商品情報追加中をあらわすstate
  const [isAdding, setAdding] = useState(false);

  //商品ダイアログ初期処理
  useEffect(() => {
    setAdding(false);
    productDataInput.setValue({});

    if (open && productData) {
      initializeProductInfo(productData);
    }
  }, [open]);

  // 商品ダイアログの初期処理(登録商品ID, 商品名設定)を実行する
  const initializeProductInfo = async (productData) => {
    let response = await getMaxProductId();

    productDataInput.setValue({
      productId: (response.maxProductId + 1).toString(),
      productName: productData.productName ? productData.productName : "",
    });
  };

  const onClickAdd = async (event) => {
    setAdding(true);
    productDataInput.Value.createdId = 1; //TODO JWT追加した後削除
    productDataInput.Value.updatedId = 1; //TODO JWT追加した後削除

    try {
      let productId = await addProduct(productDataInput.Value);

      openAddProductDialog({
        ...productData,
        productId: productId,
        productName: productDataInput.Value.productName,
      });
    } catch (e) {
      if (e.response.data === "DuplicateKeyException") {
        alert(MSG_ERR_DUPLICATED_PRODUCT_ID);
      } else {
        alert(MSG_ERR_UNEXPECTED);
      }

      setAdding(false);
    }
  };

  const onClickReturn = (event) => {
    openAddProductDialog(productData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <Box padding={2}>
        <Typography fontSize={20} fontWeight={700}>
          商品マスタ追加
        </Typography>
        <ProductInfo product={productDataInput} />
        <Grid container marginTop={2}>
          <Grid item xs textAlign="center">
            <Button
              variant="contained"
              color="error"
              onClick={onClickAdd}
              disabled={isAdding}
            >
              追加
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
